import {decorate} from "mobx";
import {SupportAction} from "./support.action";

class SupportStore extends SupportAction {}

// eslint-disable-next-line no-class-assign
SupportStore = decorate(SupportStore, {});

export default new SupportStore();
